import './App.css';
import { CssBaseline, Typography, } from '@mui/material';
import ResponsiveAppBar from './components/ResponsiveAppBar';
import ProfileHeader from './components/ProfileHeader';
import * as React from 'react';
import Box from '@mui/material/Box';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ColorModeContext from './contexts/ColorMode';
import useMediaQuery from '@mui/material/useMediaQuery';
import { grey, } from '@mui/material/colors';
import DividerStack from './components/DividerStack';
import axios from 'axios';
import { Routes, Route, } from "react-router-dom";

export default function App() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const [mode, setMode] = React.useState('light');

  React.useEffect(() => {
    async function fetchData() {
      try {
        console.log('hello');
        const response = await axios.get('https://bemaldo-api.herokuapp.com/');
        console.log('response');
        console.log(response);
      } catch (e) {
        console.log(e);
      }
    }
    fetchData();
  }, []);

  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === 'light' ? 'dark' : 'light'));
      },
    }),
    [],
  );


  React.useEffect(() => {
    setMode(prefersDarkMode ? 'dark' : 'light')
  }, [prefersDarkMode]);

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode,
          ...(mode === 'light'
            ? {
              // palette values for light mode
              primary: grey,
              divider: grey[400],
              background: {
                default: '#f5f5f5',
                paper: '#fff',
              },
              text: {
                primary: '#000',
                secondary: grey[900],
              },
            }
            : {
              // palette values for dark mode
              primary: grey,
              divider: grey[700],
              background: {
                default: grey[900],
                paper: grey[900],
              },
              text: {
                primary: grey[300],
                secondary: grey[400],
              },
            })
        },
      }),
    [mode],
  );

  return (
    <>
      <div className="App">
        <ColorModeContext.Provider value={colorMode}>
          <CssBaseline />
          <ThemeProvider theme={theme}>
            {/* profile header and app bar */}
            <Box sx={{ display: { xs: 'block', lg: 'none' } }}>
              <ProfileHeader />
            </Box>
            <ResponsiveAppBar />
            {/* Main app area */}
            <Typography
              component="div"
              sx={{
                width: { lg: `calc(100%-${240}px)` }
                , ml: { lg: `${240}px` }
                , padding: { xs: 1, md: 2, }
              }}
            >
              <Routes>
                <Route path="/" element={<DividerStack />} />
                <Route path="about" element={<DividerStack />} />
                <Route path="blog" element={<Typography align="center">Blog</Typography>} />
                <Route path="projects" element={<Typography align="center">Projects</Typography>} />
                <Route path="contact" element={<Typography align="center">Hire me contact</Typography>} />
                <Route path="*" element={<Typography align="center">Lost</Typography>} />
              </Routes>
            </Typography>
          </ThemeProvider>
        </ColorModeContext.Provider>
      </div>
      {/* FOOTER */}
      <Typography component="div" sx={{
        width: { xs: '100%', lg: `calc(100% - ${240}px)` },
        ml: { xs: 0, lg: `${240}px` },
      }} align="center">
        <footer> <small>&copy; Copyright {(new Date()).getFullYear()}, Bemaldo</small> </footer>
      </Typography>
    </>
  );
}
